import { Outlet, useLocation } from "react-router-dom";
import s from "./dashboard.module.scss";
import { UI_AUTHENTICATED_ROUTES } from "../../constants/routes";

export function Dashboard() {
  const { pathname } = useLocation();

  const filledScreens = UI_AUTHENTICATED_ROUTES.WALLET_TRANSACTIONS;
  const fillScreen = filledScreens.indexOf(pathname) > -1;

  return (
    <div className={[s.wrapper, fillScreen && s["filled-container"]].join(" ")}>
      <Outlet />
    </div>
  );
}
